import { makeArray } from './Util';

const _ = require('lodash');


/**
 * 
 */
export class NodeSet {
  constructor() {
    this.componentToNode = {};
    this.nodeToComponent = {};
    this.version =  0;  // Hack for Vue reactivity
  }


  /**
   * Return every node tracked in the NodeSet
   */
  getAllNodes() {
    return Object.keys(this.nodeToComponent);
  }


  /**
   * Return every component tracked in the NodeSet
   */
  getAllComponents() {
    return Object.keys(this.componentToNode);
  }


  /**
   * Return the node that contains the componentLabel OR
   * return the componentLabel if no node is found
   * 
   * @param {String} componentLabel Label for the target component
   */
  getNodeFromComponent(componentLabel) {
    let node = this.componentToNode[componentLabel];
    if (node && this.nodeToComponent[node].length >= 1) {
      return node;
    } else {
      return componentLabel;
    }
  }


  /**
   * Return the components contained in the label or empty
   * if the node does not exist
   * 
   * @param {String} nodeLabel Label for the target node
   */
  getComponentsFromNode(nodeLabel) {
    return this.nodeToComponent[nodeLabel] ?? [];
  }


  /**
   * Create a node with (or add to an existing node) the
   * provided components
   * 
   * @param {String} nodeLabel New (or existing) node label
   * @param {String|String[]} componentLabels Labels to add to the node
   */
  addToNode(nodeLabel, componentLabels) {
    let componentArray = makeArray(componentLabels);

    // Remove components from any existing assignments
    this.removeComponent(componentLabels);

    // Add components to the new assignment
    for (let c of componentArray) {
      this.componentToNode[c] = nodeLabel;
    }

    if (nodeLabel in this.nodeToComponent) {
      this.nodeToComponent[nodeLabel].push(...componentArray);
    } else {
      this.nodeToComponent[nodeLabel] = componentArray;
    }

    this.version++; // Increment version for Vue
  }


  /**
   * Remove the component from its associated node
   * 
   * @param {String|String[]} componentLabels Components to remove from nodes
   */
  removeComponent(componentLabels) {
    let componentArray = makeArray(componentLabels);

    for (let c of componentArray) {
      let node = this.componentToNode[c];
      _.pull(this.nodeToComponent[node], c);
      delete this.componentToNode[c];
    }

    this.version++; // Increment version for Vue
  }


  /**
   * Entirely remove a node and all components associated with it
   * 
   * @param {String} nodeLabel Node to entirely remove
   */
  removeNode(nodeLabel) {
    let components = this.nodeToComponent[nodeLabel];

    for (let c of components) {
      delete this.componentToNode[c];
    }
    delete this.nodeToComponent[nodeLabel];

    this.version++; // Increment version for Vue
  }
}